// App.vue
<template>
  <div id="app">
    <div id="header-wrapper">
      <Header></Header>
    </div>
    <div id="contentContainer">
      <transition
          name="fade"
          mode="out-in">
        <router-view/>
      </transition>
    </div>
    <div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header";
import Footer from "./components/Footer";

export default {
  components: {
    Header,
    Footer
  },
  data: function () {
    return {}
  },
  methods: {
    goTo(routeName) {
      if (this.$route.path !== "/") {
        this.$router.push({name: routeName});
      }
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href;
      // eslint-disable-next-line no-useless-escape
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  },
  computed: {},
  mounted() {
    if (this.getParameterByName('session')) {
      // eslint-disable-next-line no-undef
      sso.saveSsoUser();
    }
  },
  watch: {
    $route() {
      if (this.getParameterByName('session')) {
        // eslint-disable-next-line no-undef
        sso.saveSsoUser();
      }
    }
  }
}

</script>

<style lang="scss">
@use "@/assets/styles/variables.scss" as *;
@import '~vuejs-noty/dist/vuejs-noty.css';
@import "assets/styles/icons.css";

* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}

.tile > h2 {
  margin: 0;
}

#app {
  height: 100vh;
  width: 100%;
}

.count-header {
  position: absolute;
  top: -0.7vw;
  right: 0.5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  padding: 5px 10px;
  color: $grey;
  background-color: $dashboardBg;
}

body {
  margin: 0;
  background-color: rgb(236, 237, 239);
  color: $darkGrey;
  font-size: 14px;
}

.hover-highlight:hover {
  color: $pink;
}

#contentContainer, #header-wrapper {
  display: flex;
  justify-content: center;
  margin: auto;
  background: #ecedef;
}

#header-wrapper {
  background-color: white;
}

#header-container {
  height: $headerHeight;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
}

#contentContainer {
  background: #ecedef;
  margin: auto;
  width: 90%;
  min-height: $contentHeight;
  display: flex;
  justify-content: center;
}

.margin-right {
  margin-right: 20px;
}

.margin-right-survey {
  margin-right: 5px;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}


@media only screen and (max-width: 1650px) {
  #logo {
    left: 10px;
  }
  #headerContainer {
    padding-left: calc(#{$logoWidth} + 15px);
    border-bottom: 1px solid #eeeeee;
  }
}

/* Page Transition animation */
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@media (min-width: 2500px) {
  body {
    font-size: 19px;
  }
}

@media (min-width: 3500px) {
  body {
    font-size: 24px;
  }
}

.v-spinner .v-dot1 {
  height: 30px !important;
  width: 30px !important;
}

.v-spinner .v-dot2 {
  animation-name: colorChange !important;
  height: 15px !important;
  width: 15px !important;
}

.v-spinner .v-dot3 {
  animation-name: colorChange !important;
  height: 15px !important;
  width: 15px !important;
}

@keyframes colorChange {
  0%,
  100% {
    background-color: #00b6ed;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {

    background-color: #da2567;
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }

  30% {
    background-color: #752b77
  }
}

@-webkit-keyframes colorChange {
  0%,
  100% {
    background-color: #00b6ed;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  50% {

    background-color: #da2567;
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }

  30% {
    background-color: #752b77
  }
}

</style>